export const getSelectDropdownStyles = ({height = 40, width = '100%', isMulti = false} = {}) => {
    const heightProp = isMulti ? "minHeight" : "height";
    return {
        container: (base) => ({...base, width, textAlign: "left"}),
        control: (base) => ({...base, [heightProp]: height, alignContent: "center"}),
        valueContainer: (base) => ({...base, [heightProp]: height, alignContent: "center"}),
        indicatorsContainer: (base) => ({...base, [heightProp]: height, alignItems: "center"}),
        input: (base) => ({...base, margin: 0}),
        singleValue: (base) => ({...base, margin: 0}),
        placeholder: (base) => ({...base, margin: 0})
    };
};
